var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.title))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.allocQuantity))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.maxQuantity))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value width-1x" },
        [
          _c("el-input", {
            attrs: { type: "number", min: "1" },
            model: {
              value: _vm.reduceQuantity,
              callback: function($$v) {
                _vm.reduceQuantity = $$v
              },
              expression: "reduceQuantity"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商品名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已配货数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("可调减数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("调减数量")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bc13374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bc13374","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocItemReduce.vue
// module id = 2675
// module chunks = 0